import { CarriersController } from "../controllers/carriers-controller";
import { Carrier } from "../models/carrier"
import { CarrierFilter } from "../models/carrier-filter"
import { BusyService } from "../services/busy-service";
import { WebApiService } from "../services/web-api-service";
import { SecurityService } from "../services/security-service";
import states from "../models/state-list";
import lanes from "../models/lane-list";

//import 'ag-grid-enterprise/main';
import { activationStrategy, Router } from 'aurelia-router';
import { observable, computedFrom, autoinject } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import * as condition from './widgets/list-filter/condition';
import { Globals } from "../models/globals";
import { CarrierSearchForDivisionUsersCriteria, RefineMillSearchDialog } from "./dialogs/mill-search-carrier-refine";
import { DialogService } from "aurelia-dialog";
import { Equipment, EquipmentType } from "../models/equipment";

@singleton()
@autoinject()
export class MillSearchCarriers {
    lanes: { country: string; lanes: { name: string; abbreviation: string; }[]; }[];
    productGroups: any;

    determineActivationStrategy() {
        //activationStrategy.replace to replace the viewmodel with a new instance
        // or activationStrategy.invokeLifecycle to invoke router lifecycle methods on the existing VM
        // or activationStrategy.noChange to explicitly use the default behavior
        return activationStrategy.invokeLifecycle;
    }

    requiredInsuranceCargo: "";
    // heavyHaul: boolean;
    // diversity: boolean;
    // hazmat: boolean;
    entityTypes: any;
    // selectedEntityTypes: Array<string> = ['TRUCKS'];
    searchCriteria: CarrierSearchForDivisionUsersCriteria;
    currentQuery: string;

    constructor(
        private dialogService: DialogService,
        private busyService: BusyService,
        private securityService: SecurityService,
        private carriersController: CarriersController,
        private router: Router,
        private api: WebApiService) {

        this.lanes = lanes;
        this.states = states;
    }

    async activate(params) {

        if (!this.equipment || !this.equipment.length) {
            await Promise.all([
                this.loadEquipment(),
                this.loadEquipmentTypes(),
                this.loadProductGroups()
            ]);
        }

        this.searchCriteria = new CarrierSearchForDivisionUsersCriteria();


        if (!this.entityTypes || !this.entityTypes.length)
            this.entityTypes = await new Globals().getEntityTypes();

        if (params.query && params.query != this.currentQuery) {
            this.searchCriteria = JSON.parse(params.query);
            this.applyGridLayout();
            await this.executeSearch();
        } else if (!params.query || !this.searchResults) {
            this.applyGridLayout();
            this.filterApplied = false;
        }
        this.currentQuery = params.query;

    }

    @computedFrom("searchCriteria.equipmentTypeIds", "searchCriteria.equipmentTypeIds.length")
    get filteredEquipment(): any[] {
        // return list of ids, grouped by type
        const filteredEquipment: Array<{ typeName: string, equipment: Equipment[] }> = [];
        this.searchCriteria.equipmentTypeIds.forEach(equipmentTypeId => {
            const equipment = this.equipment.filter(o => equipmentTypeId == o.equipmentTypeId);
            if (equipment.length > 1) {
                const equipmentType = this.equipmentTypes.filter(o => o.equipmentTypeId == equipmentTypeId)[0];
                filteredEquipment.push({ typeName: equipmentType.type, equipment: equipment });
            }
        });
        return filteredEquipment;
    }
    loadEquipmentTypes() {
        this.busyService.on();
        this.api.get("Registration", "GetEquipmentTypes")
            .then((result) => {
                this.equipmentTypes = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }


    loadProductGroups() {
        this.busyService.on();
        this.api.get("Carriers", "GetProductGroups")
            .then((result) => {
                this.productGroups = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }

    states: Array<any>;
    selectedOriginStates: Array<any> = [];
    selectedDestinationStates: Array<any> = [];

    fields: Array<condition.ConditionField>;
    includeAllMills = true;

    refineSearch() {
        this.filterApplied = false;
        // // show popup with additional filter options
        // this.dialogService.open(
        //     {
        //         viewModel: RefineMillsearchDialog,
        //         model: { criteria: this.searchCriteria }
        //     })
        //     .whenClosed((result) => {
        //         if (!result.wasCancelled) {
        //             //apply any refinedCriteria changes
        //             var searchCriteria = result.output;
        //             this.search(searchCriteria);
        //         }
        //     });
    }
    configureGridOptions() {
        // show popup with additional  options
        this.dialogService.open(
            {
                viewModel: RefineMillSearchDialog,
                model: { criteria: this.searchCriteria }
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    //apply any refinedCriteria changes
                    var searchCriteria = result.output;
                    this.searchCriteria = searchCriteria;
                    this.personalizeColumns();
                }
            });
    }

    loadEquipment() {
        this.busyService.on();
        this.api.get("Registration", "GetEquipment")
            .then((result) => {
                this.equipment = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }

    filterApplied = false;
    gridContainer: any;

    searchResults = [];

    @observable
    gridApi: any;
    gridApiChanged(gridApi) {
        this.applyFilters();
        this.applyGridLayout();
    }

    applyFilters() {
        this.quickFilterChanged();
    }
    @observable
    quickFilter: string;
    quickFilterChanged() {
        this.gridApi && this.gridApi.setQuickFilter(this.quickFilter);
    }
    applyGridLayout() {
        //apply user's personalized grid layout
        this.personalizeColumns();
    }

    personalizeColumns() {
        if (this.gridApi) {
            var columnApi = this.gridApi.getModel().columnApi
            var columns = columnApi.getAllColumns();

            columnApi.setColumnVisible("preferredOrigins", this.searchCriteria.showAllPreferredLanes);
            columnApi.setColumnVisible("preferredDestinations", this.searchCriteria.showAllPreferredLanes);
            columnApi.setColumnVisible("actualOrigins", this.searchCriteria.showAllActualLanes);
            columnApi.setColumnVisible("actualDestinations", this.searchCriteria.showAllActualLanes);
            columnApi.setColumnVisible("equipment", this.searchCriteria.showAllEquipmentTypes);
        }
    }

    saveGridLayout() {
    }

    statusIsMasterApproved(statusId) {
        return statusId == 8 || statusId == 11;
    }

    private reset() {
        // this.selectedEquipment = [];
        // this.selectedOriginStates = [];
        // this.selectedDestinationStates = [];
        this.searchCriteria = new CarrierSearchForDivisionUsersCriteria();
        this.filterApplied = false;
        this.currentQuery = "";
    }

    equipment: Array<Equipment> = [];
    equipmentTypes: Array<EquipmentType> = [];
    selectedEquipment: Array<any> = [];
    selectedEquipmentTypes: EquipmentType[] = [];

    exportGrid() {
        this.gridApi.exportDataAsCsv();
    }


    newSearch() {
        this.reset();
        this.router.navigateToRoute("mill-search-carriers");
    }

    // search(criteria) {
    search() {

        //build search criteria if not already built.  Otherwise, it will be modified by the refine criteria dialog.
        const searchCriteria = this.searchCriteria; // criteria || this.buildCriteria();
        const queryJson = JSON.stringify(searchCriteria);
        if (queryJson != this.currentQuery) {
            this.router.navigateToRoute("mill-search-carriers", { query: queryJson });
        } else {
            this.executeSearch();
        }

    }

    executeSearch() {
        // custom field mapping for equipment type groups to individual equipment IDs
        //        this.searchCriteria.specialtyEquipmentIds =
        //this.equipment.filter(o => this.selectedEquipmentTypes.find(t => t.equipmentTypeId == o.equipmentTypeId)).map(o => o.id);


        //equipmentIds

        //this.searchCriteria.specialtyEquipmentIds = this.selectedEquipment;
        //            debugger;

        return this.api.submit("Carriers", "CarrierSearchForDivisionUsers", this.searchCriteria)
            .then((result) => {
                this.searchResults = JSON.parse(result.response);
                this.filterApplied = true;
            });
    }


    // buildCriteria(): CarrierSearchForDivisionUsersCriteria {
    //     var criteria = new CarrierSearchForDivisionUsersCriteria();

    //     criteria.equipmentIds =
    //         this.equipment.filter(o => this.selectedEquipmentTypes.find(t => t.equipmentTypeId == o.equipmentTypeId)).map(o => o.id);
    //     criteria.carrierTypes = this.selectedEntityTypes;
    //     criteria.requiredInsuranceCargo = this.requiredInsuranceCargo;
    //     criteria.originStates = this.selectedOriginStates;
    //     criteria.destinationStates = this.selectedDestinationStates;

    //     return criteria;
    // }



}